export type Axis = 'horizontal' | 'vertical';

export const SIZES = [
  'xsmall' as const /* 4px */,
  'small' as const /* 8px */,
  'medium' as const /* 12px */,
  'large' as const /* 16px */,
  'xlarge' as const /* 20px */,
  '2xlarge' as const /* 24px */,
  '3xlarge' as const /* 32px */,
  '4xlarge' as const /* 40px */,
  '5xlarge' as const /* 48px */,
  '6xlarge' as const /* 56px */,
  '7xlarge' as const /* 64px */,
  '8xlarge' as const /* 72px */,
  'huge' as const /* 144px */,
];

export type Spacing = (typeof SIZES)[number];

export interface SpacerProps {
  size?: Spacing;
  axis?: Axis;
}

/** If no axis is specified, become a square */
const Spacer = ({ size = 'medium', axis }: SpacerProps) => {
  const width = axis === 'vertical' ? 1 : `var(--crmis-spacing-${size}`;
  const height = axis === 'horizontal' ? 1 : `var(--crmis-spacing-${size}`;

  return (
    <div
      style={{
        display: 'block',
        width,
        height,
        minWidth: width,
        minHeight: height,
      }}
    />
  );
};

export default Spacer;
